export default "__VITE_ASSET__rLmEhgKX__"